module.exports = __webpack_public_path__ + "static/img/r-9.a6c27f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog/renovation/r-9.jpg
// module id = xIje
// module chunks = 0